import { Navigate, useNavigate, useParams } from "react-router";

import { InviteDialog } from "./invite-dialog";

export const Ref = () => {
  const { ref } = useParams<{ ref: string }>();
  const navigate = useNavigate();

  if (!ref) return <Navigate to="/" replace />;

  return (
    <>
      <InviteDialog
        isOpen
        refLink={ref}
        onOpenChange={() => {
          navigate("/", { replace: true });
        }}
      />
    </>
  );
};
